import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/institution';
const backUrl='/setting'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            ins_name:'', 
            ins_description:'',
            ins_email:'',
            ins_mobile:'',
            ins_phone:'',
            ins_address:'',
            status:'',
            user_name:'',
            pass_word:'',
            email:'',
            name:'',
            mobile:'',
            rolename:'', 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        ins_name:data.name?data.name:'', 
                        ins_description:data.description?data.description:'',
                        ins_email:data.email?data.email:'',
                        ins_mobile:data.mobile?data.mobile:'',
                        ins_phone:data.phone?data.phone:'',
                        ins_address:data.address?data.address:'',
                        status:data.status?data.status:'',
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            const {ins_name,ins_description,ins_email,ins_mobile,ins_phone,ins_address,status,
                user_name,
                pass_word,
                email,
                name,
                mobile,
                rolename,
            }=this.state;
            let params={
                ins_name,ins_description,ins_email,ins_mobile,ins_phone,ins_address,status,
                user_name,
                pass_word,
                email,
                name,
                mobile,
                rolename,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,ins_name,ins_description,ins_email,ins_mobile,ins_phone,ins_address,status,
            user_name,
            pass_word,
            email,
            name,
            mobile,
            rolename} = this.state; 
        let role=permissionCheck('roles',title);
        if(!role)
            return <Nopermission/>;
        const ins_nameValid= this.validator.message('Institution Name', ins_name, 'required');
        const ins_descriptionValid= this.validator.message('Institution Description', ins_description, 'required');
        const ins_emailValid= this.validator.message('InstitutionEmail', ins_email, 'required|email');
        const ins_mobileValid= this.validator.message('Institution Mobile', ins_mobile, 'required|phone');
        const ins_phoneValid= this.validator.message('Institution Phone', ins_phone, 'required|phone');
        const ins_addressValid= this.validator.message('Institution Address', ins_address, 'required');
        const statusValid= this.validator.message('status', status, 'required');
        let user_nameValid = '';
        let pass_wordValid = '';
        let emailValid = '';
        let nameValid = '';
        let mobileValid = '';
        let rolenameValid = '';

        if(!this.props.match.params.id){
            user_nameValid = this.validator.message('Usernaem',user_name,'required');
            pass_wordValid = this.validator.message('Password',pass_word,'required');
            emailValid = this.validator.message('Email',email,'required|email');
            nameValid = this.validator.message('Name',name,'required');
            mobileValid = this.validator.message('Mobile',mobile,'required|phone');
            rolenameValid = this.validator.message('Rolename',rolename,'required');
        }
        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title} Institution</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <h3 className="heading_a">Institution Detail</h3>
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Name<span className="req">*</span></label>
                                    <input type="text" name="ins_name" value={ins_name} onChange={this.setStateFromInput} className={ `md-input ${ins_nameValid ?'md-input-danger':''}`} /> 
                                    {ins_nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_email ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Email<span className="req">*</span></label>
                                    <input type="text" name="ins_email" value={ins_email} onChange={this.setStateFromInput} className={ `md-input ${ins_emailValid ?'md-input-danger':''}`} /> 
                                    {ins_emailValid} 
                                </div>
                            </div>
                       
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_mobile ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Mobile<span className="req">*</span></label>
                                    <input type="text" name="ins_mobile" value={ins_mobile} onChange={this.setStateFromInput} className={ `md-input ${ins_mobileValid ?'md-input-danger':''}`} /> 
                                    {ins_mobileValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_phone ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Phone">Phone<span className="req">*</span></label>
                                    <input type="text" name="ins_phone" value={ins_phone} onChange={this.setStateFromInput} className={ `md-input ${ins_phoneValid ?'md-input-danger':''}`} /> 
                                    {ins_phoneValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_address ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Address">Address<span className="req">*</span></label>
                                    <input type="text" name="ins_address" value={ins_address} onChange={this.setStateFromInput} className={ `md-input ${ins_addressValid ?'md-input-danger':''}`} /> 
                                    {ins_addressValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ins_description ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Description">Description<span className="req">*</span></label>
                                    <input type="text" name="ins_description" value={ins_description} onChange={this.setStateFromInput} className={ `md-input ${ins_descriptionValid ?'md-input-danger':''}`} /> 
                                    {ins_descriptionValid} 
                                </div>
                            </div>
                        </div>
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${status ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="status">Status<span className="req">*</span></label>
                                    <input type="text" name="status" value={status} onChange={this.setStateFromInput} className={ `md-input ${statusValid ?'md-input-danger':''}`} /> 
                                    {statusValid} 
                                </div>
                            </div>
                        </div>
                        { !this.props.match.params.id &&
                        <span>
                            <h3 className="heading_a">Super User Detail</h3>
 
                            <div className="uk-grid" data-uk-grid-margin>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${email ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="Mobile">Login Email<span className="req">*</span></label>
                                        <input type="text" name="email" value={email} onChange={this.setStateFromInput} className={ `md-input ${emailValid ?'md-input-danger':''}`} /> 
                                        {emailValid} 
                                    </div>
                                </div>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${pass_word ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="Email">Password<span className="req">*</span></label>
                                        <input type="text" name="pass_word" value={pass_word} onChange={this.setStateFromInput} className={ `md-input ${pass_wordValid ?'md-input-danger':''}`} /> 
                                        {pass_wordValid} 
                                    </div>
                                </div>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${user_name ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="name">Display Name<span className="req">*</span></label>
                                        <input type="text" name="user_name" value={user_name} onChange={this.setStateFromInput} className={ `md-input ${user_nameValid ?'md-input-danger':''}`} /> 
                                        {user_nameValid} 
                                    </div>
                                </div>
                            </div>
                        
                            <div className="uk-grid" data-uk-grid-margin>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${name ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="Mobile">Name<span className="req">*</span></label>
                                        <input type="text" name="name" value={name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                        {nameValid} 
                                    </div>
                                </div>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${mobile ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="Email">Mobile<span className="req">*</span></label>
                                        <input type="text" name="mobile" value={mobile} onChange={this.setStateFromInput} className={ `md-input ${mobileValid ?'md-input-danger':''}`} /> 
                                        {mobileValid} 
                                    </div>
                                </div>
                                <div className="uk-width-medium-1-3"> 
                                    <div className={ `md-input-wrapper ${rolename ? 'md-input-filled' : ''}`}>
                                        <label htmlFor="name">Role Name<span className="req">*</span></label>
                                        <input type="text" name="rolename" value={rolename} onChange={this.setStateFromInput} className={ `md-input ${rolenameValid ?'md-input-danger':''}`} /> 
                                        {rolenameValid} 
                                    </div>
                                </div>
                            </div>
                        </span>
                        }
                        <br/>
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn-small md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Setting/Institution/addEdit.js